import React, { useState } from "react";
import { TFormStatus } from "../../../../shared/src/codecs/codec";
import { TTransactionType1 } from "../../../../domain/codecs/TransactionType";
import { CRMButtonPrimary } from "../CRMButtonPrimary/CRMButtonPrimary";
import { CRMCardOutsidePopupFormSubmit } from "../CRMCardOutsidePopupFormSubmit/CRMCardOutsidePopupFormSubmit";
import { CRMParagraph } from "../Simple/CRMParagraph/CRMParagraph";

export const CRMCaseRollbackComponent = (props: React.PropsWithChildren<{
    formStatus: TFormStatus;
    rollbackTo: "pre_instruction" | "pre_ready_for_exchange";
    transactionType?: TTransactionType1;
    onYes: () => void;
}>): JSX.Element => {
    const [isPopupOpen, setPopupOpen] = useState<boolean>(false);

    const openPopup = () => setPopupOpen(true);

    const closePopup = () => {
        setPopupOpen(false);
    };

    const isCompletionOnly =
        props.transactionType === "transfer" || props.transactionType === "remortgage";

    const readyForLabel = isCompletionOnly ? "ready for completion" : "ready for exchange";

    const buttonLabel =
        props.rollbackTo === "pre_ready_for_exchange"
            ? `Rollback ${readyForLabel}`
            : "Rollback instruction";

    const confirmationDestination =
        props.rollbackTo === "pre_ready_for_exchange"
            ? `to before sign off for ${readyForLabel}`
            : "to before instruction";

    return (
        <>
            {/* Button */}
            <div>
                <CRMButtonPrimary
                    fullWidth={false}
                    icon="undo"
                    label={buttonLabel}
                    onClick={openPopup}
                />
            </div>

            {/* Popup */}
            {isPopupOpen &&
                <CRMCardOutsidePopupFormSubmit
                    isOpen={true}
                    title={"Are you sure?"}
                    context="warning"
                    closeText="Cancel"
                    ctaText={"Yes, rollback"}
                    size="medium"
                    onClose={closePopup}
                    onCTA={props.onYes}
                    formStatus={
                        props.formStatus === "unauthorised"
                        || props.formStatus === "twoFactorRequired"
                        || props.formStatus === "notFound" ? "failure"
                            : props.formStatus === "untouched" ? "requiresSubmission"
                            : props.formStatus}
                    validationErrors={[]}
                >
                    <CRMParagraph>
                        You are about to roll back this case {confirmationDestination}. Are you sure you want to continue?
                    </CRMParagraph>
                </CRMCardOutsidePopupFormSubmit>
            }
        </>
    );
};
